import type { Promocode } from 'common/dataService/types/promocodesTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type PromocodesState = {
  fetching: FetchingStatus | null;
  value: Promocode[] | null;
};

const initialState: PromocodesState = {
  fetching: null,
  value: null,
};

function setFetchingFunction(state: PromocodesState, action: PayloadAction<PromocodesState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setPromocodesFunction(state: PromocodesState, action: PayloadAction<PromocodesState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}

const slice = createSlice({
  name: 'dataService.promocodes.promocodes',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setPromocodes: setPromocodesFunction,
  },
});

export const { setFetching, setPromocodes } = slice.actions;
export default slice.reducer;
